// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"352fc38fe47ff9d917f6","debug-page-model-style":"5f2580e99e12071992a6"}[chunkId] + ".css";
};